// extracted by mini-css-extract-plugin
module.exports = {"social-media-list":"social-media-list_social-media-list__HX9uP","links":"social-media-list_links__6Q5CM"};